import { render, staticRenderFns } from "./IconButtonClose.vue?vue&type=template&id=12444dd4&"
import script from "./IconButtonClose.vue?vue&type=script&lang=js&"
export * from "./IconButtonClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports